import type ExtendedPropertyUri from 'owa-service/lib/contract/ExtendedPropertyUri';
import { getExtendedPropertyUri } from 'owa-service/lib/ServiceRequestUtils';

/** Extended properties that holds the value for Team Rhythm features */
export const TeamRhythmEventTypeExtendedProperty: ExtendedPropertyUri = getExtendedPropertyUri(
    '00020329-0000-0000-C000-000000000046',
    'TeamRhythmEventType',
    'String'
);

// legacy eventify event type extended property
// adding support while we transition to the new extended property
// cleaning up work item: https://dev.azure.com/outlookweb/Time%20and%20Places/_workitems/edit/342630
export const LegacyEventifyEventTypeExtendedProperty: ExtendedPropertyUri = getExtendedPropertyUri(
    '00020329-0000-0000-C000-000000000046',
    'EventifyEventType',
    'String'
);

// This is the type of the extended property value for Team Rhythm features
// can be extended to include other types of Team Rhythm events
export type TeamRhythmEventType = 'GUIDANCE';
